/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AddNewSiteSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, accountStore, config }: TypeProps = this.props;
    const LOCATION_COLUMN_SITE = 1;

    // if country list is empty
    if (!accountStore.locationLists[1] || typeof accountStore.locationLists[1] === 'string') {
      accountStore.locationLists[1] = [];
    }

    // add country into countries list if country does not already exist
    this.checkIfExist(accountStore.locationLists[1], actionDrawerStore.response.country_id) &&
      accountStore.locationLists[1].push({
        id: actionDrawerStore.response.country_id,
        name: actionDrawerStore.response.country_name,
        code: actionDrawerStore.response.country_code,
        assets_count: actionDrawerStore.response.assets_count,
      });

    // add site in sites list if the country is the selected
    actionDrawerStore.response.country_id === config.countryId &&
      accountStore.locationLists[2] &&
      accountStore.locationLists[2][0].active.push(actionDrawerStore.response);

    actionDrawerStore.locationColumn = LOCATION_COLUMN_SITE;
    actionDrawerStore.closeActionDrawer();
  }

  checkIfExist = (arr: Array, searchID: string) => {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === searchID) {
        return false;
      }
    }

    return true;
  };

  render(): React.Element<*> {
    return 'success';
  }
}
